/** Decode invite JWT payload without verifying the signature (display-only). Server still validates on register. */
export type DecodedInviteJwt = {
	tokenType?: string
	uuid?: string
	email?: string
	role?: string
}

function base64UrlToUtf8(segment: string): string {
	const b64 = segment.replace(/-/g, '+').replace(/_/g, '/')
	const pad = b64.length % 4 === 0 ? '' : '===='.slice(b64.length % 4)
	const binary = atob(b64 + pad)
	const bytes = Uint8Array.from(binary, c => c.charCodeAt(0))
	return new TextDecoder().decode(bytes)
}

export function decodeInviteJwtPayload(token: string): DecodedInviteJwt | null {
	try {
		const parts = token.split('.')
		if (parts.length < 2 || !parts[1]) return null
		const json = base64UrlToUtf8(parts[1])
		const payload = JSON.parse(json) as DecodedInviteJwt
		if (payload.tokenType !== 'invite') return null
		return payload
	} catch {
		return null
	}
}
